"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _react = _interopRequireDefault(require("react"));

var DisplayMarkdown =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DisplayMarkdown, _React$Component);

  function DisplayMarkdown() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DisplayMarkdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DisplayMarkdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      html: null
    };

    _this.composeMarkdownContent =
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(props) {
        var className, content, options, style, markdown, html;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                className = props.className, content = props.content, options = props.options, style = props.style;
                _context.next = 3;
                return fetch(content).then(function (r) {
                  return r.text();
                });

              case 3:
                markdown = _context.sent;

                if (typeof markdown === 'string') {
                  html = _react.default.createElement(_markdownToJsx.default, {
                    className: className,
                    style: style,
                    options: options
                  }, markdown);

                  _this.setState({
                    html: html
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    return _this;
  }

  (0, _createClass2.default)(DisplayMarkdown, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.composeMarkdownContent(this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var html = this.state.html;
      return html;
    }
  }]);
  return DisplayMarkdown;
}(_react.default.Component);

var _default = DisplayMarkdown;
exports.default = _default;